export const CYBER_THRESHOLDS = { lowMax: 6, moderateMax: 13, max: 20 };
export const GENAI_THRESHOLDS = { lowMax: 6, moderateMax: 17, max: 20 };

export function getRiskTier(score, thresholds = CYBER_THRESHOLDS) {
  if (score == null || score < 0) return 'unscored';
  if (score <= thresholds.lowMax) return 'green';
  if (score <= thresholds.moderateMax) return 'orange';
  return 'red';
}

export function getRiskLabel(tierOrScore, thresholds = CYBER_THRESHOLDS) {
  const tier = typeof tierOrScore === 'number' ? getRiskTier(tierOrScore, thresholds) : tierOrScore;
  switch (tier) {
    case 'green': return 'Low Hazard';
    case 'orange': return 'Moderate Hazard';
    case 'red': return 'High Hazard';
    default: return 'Unscored';
  }
}

export function getRiskBadgeClass(score, thresholds = CYBER_THRESHOLDS) {
  return `risk-${getRiskTier(score, thresholds)}`;
}

export const RISK_TIER_OPTIONS = [
  { value: '14-20', label: 'High Hazard (14-20)' },
  { value: '7-13', label: 'Moderate Hazard (7-13)' },
  { value: '1-6', label: 'Low Hazard (1-6)' },
];

export const SCALE_MAX = CYBER_THRESHOLDS.max;
